"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var types_1 = require("../util/types");
var actions_1 = __importDefault(require("../../login/actions"));
var PrivateRoute = function (props) {
    var ChildComponent = props.component;
    var path = props.path;
    var dispatch = react_redux_1.useDispatch();
    var isLoggedIn = react_redux_1.useSelector(function (state) { return state.login.isLoggedIn; });
    react_1.useEffect(function () {
        dispatch(actions_1.default.isLoggedIn());
    }, [dispatch]);
    return (react_1.default.createElement(react_router_dom_1.Route, { path: path, render: function (routeProps) {
            return isLoggedIn ? (
            /* eslint-disable react/jsx-props-no-spreading */
            react_1.default.createElement(ChildComponent, __assign({}, routeProps))) : (react_1.default.createElement(react_router_dom_1.Redirect, { to: {
                    pathname: types_1.LOGIN_PAGE,
                    state: { previous: path },
                } }));
        } }));
};
exports.default = PrivateRoute;
